/*
 * Every message module, merged into one { en, fr, es } table.
 *
 * One module per area (TRANSLATING.md, "Wave 2 partition"). Each area edits only its
 * own module; this file already lists them all, so nobody needs to touch it.
 * A key may appear in two modules only if the en/fr/es text is identical
 * (I18nMessagesTest fails otherwise).
 */
import common from './common.js';
import domain from './domain.js';
import signin from './signin.js';
import fleet from './fleet.js';
import people from './people.js';
import business from './business.js';
import shell from './shell.js';
import inspection from './inspection.js';
import hours from './hours.js';
import billing from './billing.js';

export const MODULES = { common, domain, signin, fleet, people, business, shell, inspection, hours, billing };

/** { key: { en, fr, es } } per module -> { en: { key }, fr: { key }, es: { key } }. */
export function merge(modules) {
  const out = { en: {}, fr: {}, es: {} };
  Object.values(modules).forEach((module) => {
    Object.entries(module).forEach(([key, entry]) => {
      Object.keys(out).forEach((lang) => {
        const text = entry?.[lang];
        if (text !== undefined && text !== null && text !== '') {
          out[lang][key] = text;
        }
      });
    });
  });
  return out;
}

export default merge(MODULES);
